import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjDelete"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.16311 1.6001H6.83584C6.19318 1.6001 5.67221 2.12107 5.67221 2.76373V3.34555H2.09192C1.82002 3.34555 1.59961 3.56596 1.59961 3.83786V4.5987C1.59961 4.87059 1.82002 5.091 2.09192 5.091H3.35173L3.44948 13.9132C3.45247 14.183 3.67199 14.4001 3.94176 14.4001H12.1682C12.4401 14.4001 12.6605 14.1797 12.6605 13.9078V5.091H13.9073C14.1792 5.091 14.3996 4.87059 14.3996 4.5987V3.83786C14.3996 3.56596 14.1792 3.34555 13.9073 3.34555H10.3267V2.76373C10.3267 2.12107 9.80577 1.6001 9.16311 1.6001ZM9.16294 3.34555V2.76374H6.83567V3.34555H9.16294ZM5.96522 6.70718H5.38302C5.22225 6.70718 5.09192 6.83019 5.09192 6.98193V11.9274C5.09192 12.0791 5.22225 12.2021 5.38302 12.2021H5.96522C6.12599 12.2021 6.25632 12.0791 6.25632 11.9274V6.98193C6.25632 6.83019 6.12599 6.70718 5.96522 6.70718ZM7.71138 6.70718H8.29358C8.45435 6.70718 8.58468 6.83019 8.58468 6.98193V11.9274C8.58468 12.0791 8.45435 12.2021 8.29358 12.2021H7.71138C7.55061 12.2021 7.42028 12.0791 7.42028 11.9274V6.98193C7.42028 6.83019 7.55061 6.70718 7.71138 6.70718ZM10.6224 6.70718H10.0402C9.87946 6.70718 9.74913 6.83019 9.74913 6.98193V11.9274C9.74913 12.0791 9.87946 12.2021 10.0402 12.2021H10.6224C10.7832 12.2021 10.9135 12.0791 10.9135 11.9274V6.98193C10.9135 6.83019 10.7832 6.70718 10.6224 6.70718Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_delete = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_delete as default };
